import { Moment } from 'moment';

export enum ExportDateType {
  DeliveryDateTime = 'DELIVERY_DATE_TIME',
  ETD = 'ETD'
}

export enum ImportDateType {
  DeliveryDateTime = 'DELIVERY_DATE_TIME',
  ETA = 'ETA'
}

export enum AccountingDateType {
  InvoiceDate = 'INVOICE_DATE',
  ETA = 'ETA',
  ETD = 'ETD'
}

export enum JobContainerStatus {
  All = 'ALL',
  Active = 'ACTIVE'
}

interface IBaseFilter {
  isExport: boolean;
}

export interface IReportOperationFilter extends IBaseFilter {
  agents: any[];
  consignees: any[];
  consignors: any[];
  warehouses: any[];
  vessels: any[];
  dateType: string;
  fromDate: string | Moment;
  toDate: string | Moment;
  jobStatus: string;
  containerStatus: string;
}

export interface IReportAccountingFilter extends IBaseFilter {
  ars: any[];
  consigns: any[];
  vessels: any[];
  dateType: string;
  fromDate: string | Moment;
  toDate: string | Moment;
  jobStatus: string;
}
